import React 			from 'react';

import BLComponent from '../core/_BLComponent.jsx';

export default class DSAReportButton extends BLComponent {
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = '', reportArea, contentType, contentId, contentUrl = 'self'} = this.props;
		
		return (
			<button className={`btn btn--link ${classes}`} onClick={() => window.gotoReportPage(reportArea, contentType, contentId, "self")}>
				{this.props.children}
			</button>
		);
	}
}